import { restDelete, restGet, restPost } from "apiCommandsExecutor/rest";

import { AliasAvailabilityDto, MenuAliasDto } from "./restModels";
import { CreateMenuAliasRequestDto } from "./restRequests";

// ===== Ссылки на меню (REST /api/rest/warehouse/v1) =====

export const getMenuAliases = (menuId: number) =>
    restGet<MenuAliasDto[]>(`/menus/${menuId}/aliases`);

export const createMenuAlias = (menuId: number, body: CreateMenuAliasRequestDto) =>
    restPost<MenuAliasDto>(`/menus/${menuId}/aliases`, body);

// Возвращает оставшиеся ссылки меню — отдельный запрос за списком не нужен.
export const deleteMenuAlias = (menuId: number, alias: string) =>
    restDelete<MenuAliasDto[]>(`/menus/${menuId}/aliases/${encodeURIComponent(alias)}`);

// Валидация (формат, чёрный список, лимит, занятость) целиком на бэке.
export const checkAliasAvailability = (alias: string) =>
    restGet<AliasAvailabilityDto>("/aliases/availability", { alias });
